/*handleFormSubmit = (e) => {
    const validation = Field.validateAllFields(this.state.fields);
    this.setState({fields: {...validation.fields}, formValidated: validation.isAllValid});
};

onChange = (field, e) => {
    const value = e.target.value;
    const {fields} = this.state;

    if (field.validate(value, true).getIsInvalid()) {
        setTimeout(() => {
            field.validate();
            this.setState({fields: {...fields, [field.key]: {...field}}});
        }, 1000);
    } else {
        field.setValue(value);
    }

    this.setState({fields: {...fields, [field.key]: {...field}}});
};

onBlurHandler = (field, e) => {
    field.validate();
    const {fields} = this.state;
    this.setState({fields: {...fields, [field.key]: {...field}}});
};
*/

class Field {

    constructor(
        key,
        value='',
        placeholder='',
        onTypeFn= v => /.*/g.test(v),
        onBlurFn= v => /.*/g.test(v),
        isValidated=false,
        isInvalid=false,
        isValid=false,
        onTypeErrMsg='',
        onBlurErrMsg=''
    ) {
        this._key = key;
        this._value = value;
        this._placeholder = placeholder;
        this._onTypeFn = onTypeFn;
        this._onBlurFn = onBlurFn;
        this._isValidated = isValidated;
        this._isInvalid = isInvalid;
        this._isValid = isValid;
        this._onTypeErrMsg = onTypeErrMsg;
        this._onBlurErrMsg = onBlurErrMsg;
    }

    static validateAllFields = (fields) => {
        let isAllValid = true;
        for (const key in fields) {
            fields[key].validate();
            if (fields[key].getIsInvalid()) {
                isAllValid = false;
            }
        }
        return {fields: {...fields}, isAllValid: isAllValid};
    };

    validate = (value=null, onType=false) => {
        const valueToValidate = value !== null ? value : this._value;
        const isValid = onType ? this._onTypeFn(valueToValidate) : this._onBlurFn(valueToValidate);
        this._isInvalid = !isValid;
        this._isValid = this._onBlurFn(valueToValidate);//isValid && !onType;
        this._isValidated = true;
        return this;
    };

    getIsValid = () => {
        return this._isValidated && this._isValid;
    };

    getIsInvalid = () => {
        return this._isValidated && this._isInvalid;
    };

    getIsValidated = () => {
        return this._isValidated;
    };

    getKey() {
        return this._key;
    }

    setKey(value) {
        this._key = value;
    }

    getValue() {
        return this._value;
    }

    setValue(value) {
        this._value = value;
    }

    getPlaceholder() {
        return this._placeholder;
    }

    setPlaceholder(value) {
        this._placeholder = value;
    }

    setIsValidated(value) {
        this._isValidated = value;
    }

    setIsInvalid(value) {
        this._isInvalid = value;
    }

    getOnTypeFn() {
        return this._onTypeFn;
    }

    setOnTypeFn(value) {
        this._onTypeFn = value;
    }

    getOnBlurFn() {
        return this._onBlurFn;
    }

    setOnBlurFn(value) {
        this._onBlurFn = value;
    }

    getOnTypeErrMsg() {
        return this._onTypeErrMsg;
    }

    setOnTypeErrMsg(value) {
        this._onTypeErrMsg = value;
    }

    getOnBlurErrMsg() {
        return this._onBlurErrMsg;
    }

    setOnBlurErrMsg(value) {
        this._onBlurErrMsg = value;
    }
}

export default Field;